import React, { ReactElement } from 'react'
import { Center, Stack } from '@mantine/core'
import { NextPageWithLayout } from 'types/nextCustomType'
import { SessionLayout } from 'components/site'
import ResetForm from 'modules/Password/Reset/Form'
import getT from 'next-translate/getT'
import { GetServerSidePropsContext } from 'next'
import { SessionPaper } from 'components/ui'

const Reset: NextPageWithLayout = () => {
  return (
    <Stack h="100%" align="center" justify="space-between">
      <Center h="100%">
        <SessionPaper noBorder>
          <ResetForm />
        </SessionPaper>
      </Center>
    </Stack>
  )
}

Reset.getLayout = function getLayout(page: ReactElement) {
  return <SessionLayout>{page}</SessionLayout>
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  const t = await getT(locale, 'pagePwdReset')
  return {
    props: {
      pageTitle: t('pagePwdReset:title'),
    },
  }
}

export default Reset
